import { useState, useEffect } from 'react';
import request from 'helpers/request';

const requestCache = new Map();

const useProvincialFees = (provinceId, bikeModel) => {
  const [fees, setFees] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!provinceId || !bikeModel?.id) {
      setFees(null);
      return;
    }

    const cacheKey = `${bikeModel.id}-${provinceId}`;
    let cancelled = false;

    const fetchFees = async () => {
      setLoading(true);
      setError(null);

      try {
        let requestPromise = requestCache.get(cacheKey);

        if (!requestPromise) {
          requestPromise = request(`/api/configurator/bikes/model/${bikeModel.id}/price?provinceid=${provinceId}`);
          requestCache.set(cacheKey, requestPromise);

          requestPromise.finally(() => {
            requestCache.delete(cacheKey);
          });
        }

        const response = await requestPromise;

        if (!cancelled) {
          setFees(response.data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err);
          setFees(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchFees();

    return () => {
      cancelled = true;
    };
  }, [provinceId, bikeModel?.id]);

  return { fees, loading, error };
};

export default useProvincialFees;
